module.exports = __webpack_public_path__ + "img/41.8.TSS.55928c00.png";